import React, {useState} from 'react';
import s from './TableChecks.module.css';
import style from '../BonusesTable/BonusesTable.module.css';
import LightGreenButton from '../../../../Components/Buttons/LightGreenButton';
import GridTableHead from '../../../../Components/GridTableHead/GridTableHead';
import {useTranslation} from 'react-i18next';
import {
	useCreateBonusCheckMutation,
	useCreateManyBonusCheckMutation,
	useGetBonusCheckListQuery,
} from '../../../../redux/DepotSlice/depotCashierApi';
import {BonusType} from '../../../../types/TypesUserOrders';
import PreLoaderComponent from '../../../../assets/Animations/PreLoaderComponent/PreLoaderComponent';
import {toast} from 'react-toastify';
import TableChecksRowElement from './TableChecksRowElement';
import {getMonthStart} from '../../../../assets/utils/dateUtils';

const TableChecks = () => {
	const {t} = useTranslation();
	const [checkedElements, setCheckedElements] = useState<string[]>([]);
	const [showAll, setShowAll] = useState(false);

	const {data, isLoading} = useGetBonusCheckListQuery(getMonthStart());
	const [createBonusCheck] = useCreateBonusCheckMutation();
	const [createManyBonusCheck] = useCreateManyBonusCheckMutation();

	const handleCheckElement = (id: string) => {
		setCheckedElements((prev) =>
			prev.includes(id) ? prev.filter((el) => el !== id) : [...prev, id],
		);
	};
	const handleClickAction = async (id: number) => {
		try {
			const response = await createBonusCheck(id);
			if (response?.data?.approve) {
				toast.success(response.data.message?.textmsg);
			} else {
				toast.error(response?.data?.message?.textmsg);
			}
		} catch (e: any) {
			toast.error(e.response?.data?.message?.textmsg);
		}
	};
	const handleCreateManyChecks = async () => {
		const ids = checkedElements.map((e) => +e);
		try {
			const response = await createManyBonusCheck(ids);
			if (response?.data?.approve) {
				toast.success(response.data?.edited);
			} else {
				toast.error(response?.data?.error);
			}
		} catch (e: any) {
			toast.error(e.response?.data?.message?.textmsg);
		}
	};
	return (
		<div className={s.container}>
			<div className={style.tableTitle}>{t('Список чеків на складі')}</div>
			<div className={s.tableGrid}>
				<GridTableHead 
					columns={['Дата', "Ім'я", 'Бонус', 'Статус', 'Дія']}
					gridTemplateColumns="repeat(5, 1fr)"
					customClassName={s.tableRow}
				/>

				{isLoading ? (
					<PreLoaderComponent type={'circle'} size={'big'} />
				) : (
					<>
						{data?.bonuses && data.bonuses.length > 0 ? (
							<>
								{(showAll ? data.bonuses : data.bonuses.slice(0, 10)).map(
									(bonus: BonusType) => {
										const checked = checkedElements.includes(
											bonus.id.toString(),
										);
										return (
											<TableChecksRowElement
												key={bonus.id}
												bonus={bonus}
												checked={checked}
												handleChange={handleCheckElement}
												handleClickAction={handleClickAction}
											/>
										);
									},
								)}

								<div className={style.buttonWrapper}>
									{!showAll && data.bonuses.length > 10 && (
										<LightGreenButton
											text={t('Дивитися більше')}
											onClick={() => setShowAll(true)}
											type={'button'}
										/>
									)}
									{checkedElements.length > 0 && (
										<LightGreenButton
											text={t('Підтвердити обрані')}
											onClick={handleCreateManyChecks}
											type={'button'}
										/>
									)}
								</div>
							</>
						) : null}
					</>
				)}
			</div>
		</div>
	);
};

export default TableChecks;
